import { memo, Suspense, useCallback, useState } from 'react';
import { loadable } from '@direct-frontend/modules-render';
import { useAIAssistantNotificationPresentation } from './lib/useAIAssistantNotificationPresentation';
import { type AIAssistantProps } from './types';

const AIAssistantContentLazy = loadable(() => import(/* webpackChunkName: "alty" */ './AIAssistantContent'));

/**
 * Подготавливает автоматическое открытие Alty до загрузки его интерфейса.
 * Хост заранее запрашивает нотификацию и представляет её в общей очереди, поэтому Dashboard и News
 * не появляются раньше только из-за того, что код интерфейса ещё загружается.
 */
export const AIAssistant = memo(function AIAssistant(props: AIAssistantProps) {
    const [openFromNotification, setOpenFromNotification] = useState<VoidFunction | null>(null);
    const registerNotificationOpenHandler = useCallback((handler: VoidFunction | null) => {
        // Без обёртки React воспримет handler как функцию обновления state и сразу вызовет её.
        setOpenFromNotification(() => handler);
    }, []);
    const { notification, cancelAutomaticOpening } = useAIAssistantNotificationPresentation(openFromNotification);

    return (
        <div className={props.className}>
            <Suspense fallback={null}>
                <AIAssistantContentLazy
                    registerPortalContainer={props.registerPortalContainer}
                    registerNotificationOpenHandler={registerNotificationOpenHandler}
                    notification={notification}
                    onManualOpen={cancelAutomaticOpening}
                />
            </Suspense>
        </div>
    );
});
